// Global API Interceptor - handles session validation & redirects

let redirectCallback = null;

export const setRedirectCallback = (callback) => {
  redirectCallback = callback;
};

/**
 * Wraps all API calls with error handling
 * If backend is down or session invalid (401/403), redirects to login
 */
export const apiCall = async (url, options = {}) => {
  try {
    const response = await fetch(url, {
      credentials: 'include', // Include HTTP-only cookies
      ...options
    });

    // Check if response is ok (200-299)
    if (!response.ok) {
      // 401 = Unauthorized (session expired/invalid)
      // 403 = Forbidden
      if (response.status === 401 || response.status === 403) {
        console.warn('Session invalid or expired. Redirecting to login...');
        if (redirectCallback) redirectCallback();
        throw new Error('Session expired. Please login again.');
      }

      // Other errors (500, 404, etc)
      throw new Error(`API Error: ${response.status} ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    // Catch network errors (backend offline, etc)
    console.error('API call failed:', error.message);
    
    // If it's a connection error or 5xx, show user-friendly message
    if (error.message.includes('Failed to fetch') || error.message.includes('offline')) {
      throw new Error('Backend is unavailable. Please try again later.');
    }

    throw error;
  }
};

/**
 * Alternative: Use fetch interceptor (more global approach)
 * Wrap this in App.jsx
 */
export const setupApiInterceptor = (navigateFn) => {
  setRedirectCallback(() => {
    navigateFn('/'); // Redirect to login page
  });
};
